export default __webpack_public_path__ + "static/media/waiting.cb4a2b21.svg";